import { useLingui } from '@lingui/react/macro';
import { Toaster } from 'app-ui/components';

export const AppToaster = () => {
  const { t } = useLingui();

  const getToastProps = () => ({
    closeLabel: t`Close`,
    cancelLabel: t`Cancel`,
  });

  return (
    <Toaster aria-label={t`Notifications`} getToastProps={getToastProps} />
  );
};
